module.exports = __webpack_public_path__ + "img/Болезни локтевого сустава.9a9dded4.jpg";